interface MetadataSectionProps {
  alias?: string;
  sorted?: boolean;
  selfEdges?: boolean;
  editable: boolean;
  onChange?: (metadata: {
    alias?: string;
    sorted?: boolean;
    selfEdges?: boolean;
  }) => void;
}

export const MetadataSection = ({
  alias,
  sorted,
  selfEdges,
  editable,
  onChange,
}: MetadataSectionProps) => {
  return (
    <div>
      <h4 className="text-chariot-text-primary mb-1 text-[10px] font-semibold">
        Metadata
      </h4>
      <div className="space-y-1.5">
        {alias && (
          <div>
            <label className="text-chariot-text-secondary text-[8px] font-semibold uppercase">
              Alias
            </label>
            <code className="bg-chariot-background-secondary mt-0.5 block rounded px-1.5 py-0.5 text-[9px]">
              {alias}
            </code>
          </div>
        )}

        <div className="flex items-center gap-2">
          <label className="text-chariot-text-primary flex items-center gap-1 text-[9px]">
            <input
              type="checkbox"
              checked={sorted || false}
              onChange={e =>
                onChange?.({ alias, sorted: e.target.checked, selfEdges })
              }
              disabled={!editable}
              aria-label="Sorted"
              className="h-2.5 w-2.5 rounded"
            />
            Sorted
          </label>

          <label className="text-chariot-text-primary flex items-center gap-1 text-[9px]">
            <input
              type="checkbox"
              checked={selfEdges || false}
              onChange={e =>
                onChange?.({ alias, sorted, selfEdges: e.target.checked })
              }
              disabled={!editable}
              aria-label="Self Edges"
              className="h-2.5 w-2.5 rounded"
            />
            Self Edges
          </label>
        </div>
      </div>
    </div>
  );
};
